/**
 * ss-header-ui.js — Single coordinator for header overlays
 * Ensures only one of: search | account | mega | drawer | cart is open.
 */
(function () {
  'use strict';

  var BUS = 'ss:header-close-all';

  function closeMegaMenus(except) {
    document.querySelectorAll('.ss-nav__details[open]').forEach(function (d) {
      if (except && d === except) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function closeAccount(except) {
    document.querySelectorAll('[data-ss-account].is-open').forEach(function (wrap) {
      if (except && wrap === except) return;
      wrap.classList.remove('is-open');
      var btn = wrap.querySelector('[data-ss-account-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeSearch(except) {
    document.querySelectorAll('.ss-search details[open]').forEach(function (details) {
      if (except && details === except) return;
      var modal = details.closest('details-modal');
      if (modal && typeof modal.close === 'function') {
        modal.close(false);
      } else {
        details.removeAttribute('open');
      }
    });
    document.body.classList.remove('ss-search-open');
  }

  function closeDrawer(except) {
    document.querySelectorAll('details.ss-drawer[open], .menu-drawer-container[open]').forEach(function (d) {
      if (except && d === except) return;
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
    });
  }

  function closeCart() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    document.querySelectorAll('cart-drawer.active, .drawer.is-open, #CartDrawer').forEach(function (el) {
      el.classList.remove('active', 'is-open');
    });
  }

  function closeAll(except) {
    except = except || {};
    if (!except.mega) closeMegaMenus(except.megaEl);
    if (!except.account) closeAccount(except.accountEl);
    if (!except.search) closeSearch(except.searchEl);
    if (!except.drawer) closeDrawer(except.drawerEl);
    if (!except.cart) closeCart();
  }

  document.addEventListener(BUS, function () {
    closeAll();
  });

  /* Mega open → close others */
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || !details.classList) return;

    if (details.classList.contains('ss-nav__details') && details.open) {
      closeAll({ mega: true, megaEl: details });
      var header = document.querySelector('.ss-header');
      if (header) {
        document.documentElement.style.setProperty(
          '--ss-mega-top',
          Math.round(header.getBoundingClientRect().bottom + 8) + 'px'
        );
      }
    }

    if (details.classList.contains('ss-drawer') || details.classList.contains('menu-drawer-container')) {
      if (details.open) closeAll({ drawer: true, drawerEl: details });
    }

    if (details.closest && details.closest('.ss-search') && details.open) {
      document.body.classList.add('ss-search-open');
      document.documentElement.classList.add('ss-header-above-search');
      closeAll({ search: true, searchEl: details });
      var header = document.querySelector('.ss-chrome-header, .ss-header');
      if (header) {
        var bottom = header.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--ss-chrome-h', Math.round(bottom) + 'px');
      }
    }
    if (details.closest && details.closest('.ss-search') && !details.open) {
      document.body.classList.remove('ss-search-open');
      document.documentElement.classList.remove('ss-header-above-search');
    }
  }, true);

  /* Account */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-account-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var wrap = btn.closest('[data-ss-account]');
      if (!wrap) return;
      var willOpen = !wrap.classList.contains('is-open');
      closeAll({ account: true, accountEl: wrap });
      if (willOpen) {
        wrap.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      } else {
        wrap.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      return;
    }

    if (!e.target.closest('[data-ss-account]')) closeAccount();
    if (e.target.closest('summary.ss-nav__link')) return;
    if (!e.target.closest('.ss-nav__details') && !e.target.closest('.ss-mega')) closeMegaMenus();
  });

  /* Desktop: keep chrome elevated while mega is open */
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!details || !details.classList || !details.classList.contains('ss-nav__details')) return;
    var chrome = document.querySelector('.ss-chrome-header');
    if (!chrome) return;
    chrome.classList.toggle('ss-mega-open', !!details.open);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Cart icon → exclusive open */
  document.addEventListener('click', function (e) {
    var cartBtn = e.target.closest('#cart-icon-bubble, .ss-header__cart');
    if (!cartBtn) return;
    closeAll({ cart: true });
  }, true);

  /* Keep header above search overlay */
  function syncHeaderLayer() {
    var shell = document.querySelector('.ss-shell.header-wrapper, .header-wrapper.ss-shell, .ss-header');
    if (!shell) return;
    if (document.body.classList.contains('ss-search-open')) {
      document.documentElement.classList.add('ss-header-above-search');
    } else {
      document.documentElement.classList.remove('ss-header-above-search');
    }
  }
  document.addEventListener('toggle', syncHeaderLayer, true);

  window.ssHeaderUI = { closeAll: closeAll };
})();
